import React from 'react';
import axios from 'axios';
import qs from 'qs';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';
import { withSnackbar } from 'notistack';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import { setData } from '../../actions/index';

const styles = theme => ({
  root: {},
  saveButton: {
    marginTop: 10,
    backgroundColor: '#f56a12',
    '&:hover': {
      backgroundColor: '#C24C03',
    },
  },
});

const mapStateToProps = state => {
  return {
    selectedPupil: state.selectedPupil,
    user: state.user,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    setData: (data, type) => dispatch(setData(data, type)),
  };
}

class ReportConcernPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isSubmitting: false,
      text: '',
    };

    this.axiosCancel = null;

    this.onSaveButtonClick = this.onSaveButtonClick.bind(this);
  }

  componentWillUnmount() {
    if (this.axiosCancel) {
      this.axiosCancel();
    }
  }

  onSaveButtonClick() {
    const {
      t,
      enqueueSnackbar,
      selectedPupil,
    } = this.props;
    const {
      text,
    } = this.state;

    this.setState({
      isSubmitting: true,
    });

    axios
      .post(
        `${window.apiUrl}/addconcern`,
        qs.stringify({
          pupil_id: selectedPupil.id,
          text,
        }),
        {
          cancelToken: new axios.CancelToken((c) => { this.axiosCancel = c }),
        }
      )
      .then((response) => {
        if (response.data.error) {
          enqueueSnackbar(response.data.error, {
            variant: 'error',
            autoHideDuration: 3000,
          });
        } else {
          enqueueSnackbar(t('You have successfully added a concern.'), {
            variant: 'success',
            autoHideDuration: 2000,
          });

          this.setState({
            text: '',
          });
        }
      })
      .catch((thrown) => {})
      .finally(() => {
        this.setState({
          isSubmitting: false,
        });
      })
    ;
  }

  render() {
    const {
      classes,
      t,
      user,
    } = this.props;
    const {
      isSubmitting,
      text,
    } = this.state;

    return (
      <div className={`report-concern-page ${classes.root}`}>
        <h2>{t('Report concern')}</h2>
        {user?.pupil_concerns_help_text && (
          <p>{user.pupil_concerns_help_text}</p>
        )}
        <TextField
          autoFocus
          fullWidth
          multiline
          variant="outlined"
          rows={3}
          label={t('Text')}
          value={text}
          onChange={(event) => {
            this.setState({
              text: event.target.value,
            });
          }}
        />
        <Button
          onClick={this.onSaveButtonClick}
          color="primary"
          variant="contained"
          disabled={isSubmitting}
          className={`save-button ${classes.saveButton}`}
        >
          {isSubmitting && (
            <>
              <CircularProgress size={14} />
              <span> {t('Submitting ...')}</span>
            </>
          )}
          {!isSubmitting && t('Submit')}
        </Button>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(styles)(withSnackbar(withTranslation()(ReportConcernPage)))
);
